import { lazyLoad } from "utils/loadable";

export const EmployerJobDraft = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerJobDraft
);